import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Utility
import Error404 from "../pages/Utility/Error404";
import Maintenance from "../pages/Utility/Maintenance";

// Forms
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormElements from "../pages/Forms/FormElements";
import FormMask from "../pages/Forms/FormMask";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";

//Ui

// import Profile from "../pages/User/Profile";
import AddCustomers from "../pages/Customers/AddCustomers";
import Customers from "../pages/Customers/Customers";
import Inventory from "../pages/Inventory";
import OrderManagement from "../pages/Orders";
import AddOrder from "../pages/Orders/AddOrder";
import ViewOrderAriba from "../pages/Orders/ViewOrderAriba";
import ViewOrderAspeed from "../pages/Orders/ViewOrderAspeed";
import AddSimpleProduct from "../pages/Product/AddSimpleProduct";
import Products from "../pages/Product/Products";
import PromoCode from "../pages/PromoCode";
import AddPromoCode from "../pages/PromoCode/AddPromoCode";
import ViewInventoryLog from "../pages/Inventory/ViewInventoryLog";
import CustomerReport from "../pages/Report/CustomerReport";
import MarketingReport from "../pages/Report/MarketingReport";
import SalesByCategory from "../pages/Report/SalesByCategory";
import SalesByProduct from "../pages/Report/SalesByProduct";
import SalesReport from "../pages/Report/SalesReport";
import Review from "../pages/Review";
import ViewReview from "../pages/Review/ViewReview";
import Settings from "../pages/Settings";
import General from "../pages/Settings/General";
import Appearance from "../pages/Settings/Appearance";
import HomepagePolicy from "../pages/Settings/HomepagePolicy";
import ContentPages from "../pages/Settings/ContentPages";
import EditContentPage from "../pages/Settings/ContentPages/EditContentPage";
import NavigationMenu from "../pages/Settings/NavigationMenu";
import Payment from "../pages/Settings/Payment";
import AddPaymentMethod from "../pages/Settings/Payment/AddPaymentMethod";
import Categories from "../pages/Settings/Product/Categories";
import AddCategory from "../pages/Settings/Product/Categories/AddCategory";
import Configurations from "../pages/Settings/Product/Configurations";
import ViewConfiguration from "../pages/Settings/Product/Configurations/ViewConfiguration";
import Manufactures from "../pages/Settings/Product/Manufactures";
import Models from "../pages/Settings/Product/Models";
import Services from "../pages/Settings/Product/Services";
import AddService from "../pages/Settings/Product/Services/AddService";
import ViewService from "../pages/Settings/Product/Services/ViewService";
import AddRoleAndPermission from "../pages/Settings/Role And Permissions/AddRole";
import RolesAndPermissions from "../pages/Settings/Role And Permissions/RolesAndPermissions";
import Shipping from "../pages/Settings/Shipping";
import AddShippingMethod from "../pages/Settings/Shipping/AddShippingMethod";
import AddShippingRate from "../pages/Settings/Shipping/AddShippingRate";
import ShippingRates from "../pages/Settings/Shipping/ShippingRates";
import Users from "../pages/Settings/Users";
import AddUser from "../pages/Settings/Users/AddUser";
import Support from "../pages/Support";
import ViewInquiry from "../pages/Support/ViewInquiry";
import UserProfile from "../pages/User/UserProfile";
import NotAuthorized from "../pages/Utility/NotAuthorized";
import Vouchers from "../pages/Vouchers";
import AddVoucher from "../pages/Vouchers/AddVoucher";
import Banners from "../pages/Banners";
import AddBanner from "../pages/Banners/AddBanner";
import AddSchool from "../pages/Settings/School/AddSchool";
import School from "../pages/Settings/School";

const authProtectedRoutes = [

	//user
	{ path: "/user-profile", component: <UserProfile title={'Profile'} />, requiredPermission: "view-setting", },

	// customers
	{ path: "/customer", component: <Customers />, requiredPermission: "view-customer", },
	{ path: "/add-customer", component: <AddCustomers type="Add" title="Add Customer" />, requiredPermission: "create-customer" },
	{ path: "/edit-customer/:ID", component: <AddCustomers type="Edit" title="Edit Customer" />, requiredPermission: "edit-customer" },

	// products
	{ path: "/product-listing", component: <Products />, requiredPermission: "view-product" },
	{ path: "/:addType/add-product", component: <AddSimpleProduct type="Add" title="Add Product" simple={true} />, requiredPermission: "create-product" },
	{ path: "/:addType/add-product", component: <AddSimpleProduct type="Add" title="Add Product" simple={false} />, requiredPermission: "create-product" },
	{ path: "/edit-product/:ID/:addType", component: <AddSimpleProduct type="Edit" title="Edit Product" />, requiredPermission: "edit-product" },

	// Setting
	{ path: "/settings", component: <Settings />, requiredPermission: "view-setting" },
	{ path: "/settings-general", component: <General />, requiredPermission: "view-setting" },
	{ path: "/settings-appearance", component: <Appearance />, requiredPermission: "view-setting" },
	{ path: "/settings-homepage-policy", component: <HomepagePolicy />, requiredPermission: "view-setting" },
	{ path: "/settings-content-pages", component: <ContentPages />, requiredPermission: "view-setting" },
	{ path: "/settings-content-pages/add", component: <EditContentPage type="Add" />, requiredPermission: "edit-setting" },
	{ path: "/settings-content-pages/edit/:ID", component: <EditContentPage type="Edit" />, requiredPermission: "edit-setting" },
	{ path: "/settings-navigation-menu", component: <NavigationMenu />, requiredPermission: "view-setting" },
	{ path: "/settings-users", component: <Users />, requiredPermission: "view-setting" },
	{ path: "/add-user", component: <AddUser type="Add" title="Add User" />, requiredPermission: "create-setting" },
	{ path: "/edit-user/:ID", component: <AddUser type="Edit" title="Edit User" />, requiredPermission: "edit-setting" },
	{ path: "/settings-roles", component: <RolesAndPermissions />, requiredPermission: "view-setting" },
	{ path: "/add-role", component: <AddRoleAndPermission type="Add" title="Add Role" />, requiredPermission: "create-setting" },
	{ path: "/edit-role/:ID", component: <AddRoleAndPermission type="Edit" title="Edit Role" />, requiredPermission: "view-setting" },
	{ path: "/settings-product-categories", component: <Categories title="Categories" />, requiredPermission: "view-setting" },
	{ path: "/add-settings-product-categories", component: <AddCategory type="Add" title="Add Category" />, requiredPermission: "create-setting" },
	{ path: "/edit-settings-product-categories/:ID", component: <AddCategory type="Edit" title="Edit Category" />, requiredPermission: "edit-setting" },
	{ path: "/settings-product-manufacturers", component: <Manufactures title="Manufacturers" />, requiredPermission: "view-setting" },
	{ path: "/settings-product-models", component: <Models title="Models" />, requiredPermission: "view-setting" },
	{ path: "/settings-product-configurations", component: <Configurations title="Configurations" />, requiredPermission: "view-setting" },
	{ path: "/settings-product-configurations/:module", component: <ViewConfiguration title="View Configuration" />, requiredPermission: "view-setting" },
	{ path: "/settings-product-services", component: <Services title="Services Types" />, requiredPermission: "view-setting" },
	{ path: "/settings-view-product-services/:ID", component: <ViewService title="Services Types" />, requiredPermission: "view-setting" },
	{ path: "/settings-add-product-service/:module", component: <AddService type="Add" title="Add Service" />, requiredPermission: "create-setting" },
	{ path: "/settings-edit-product-service/:module/:ID", component: <AddService type="Edit" title="Edit Service" />, requiredPermission: "edit-setting" },
	{ path: "/settings-shipping-methods", component: <Shipping title="Shipping Methods" />, requiredPermission: "view-setting" },
	{ path: "/settings-add-shipping-method", component: <AddShippingMethod title="Add Shipping Methods" type="Add" />, requiredPermission: "create-setting" },
	{ path: "/settings-edit-shipping-method/:ID", component: <AddShippingMethod title="Edit Shipping Methods" type="Edit" />, requiredPermission: "edit-setting" },
	{ path: "/settings-shipping-rates", component: <ShippingRates title="Shipping Rates" />, requiredPermission: "view-setting" },
	{ path: "/settings-add-shipping-rate", component: <AddShippingRate title="Add Shipping Rates" type="Add" />, requiredPermission: "create-setting" },
	{ path: "/settings-edit-shipping-rate/:ID", component: <AddShippingRate title="Edit Shipping Rates" type="Edit" />, requiredPermission: "edit-setting" },
	{ path: "/settings-payment-methods", component: <Payment title="Payment Methods" />, requiredPermission: "view-setting" },
	{ path: "/settings-add-payment-method", component: <AddPaymentMethod title="Add Payment Method" type="Add" />, requiredPermission: "create-setting" },
	{ path: "/settings-edit-payment-method/:ID", component: <AddPaymentMethod title="Edit Payment Method" type="Edit" />, requiredPermission: "edit-setting" },
	{ path: "/settings-school", component: <School title="Schools" />, requiredPermission: "view-setting" },
	{ path: "/settings-add-school", component: <AddSchool title="Add School" type="Add" />, requiredPermission: "create-setting" },
	{ path: "/settings-edit-school/:ID", component: <AddSchool title="Edit School" type="Edit" />, requiredPermission: "edit-setting" },

	//order
	{ path: "/order", component: <OrderManagement title="Orders" />, requiredPermission: "view-order" },
	{ path: "/add-order", component: <AddOrder title="Add Order" type="Add" />, requiredPermission: "create-order" },
	{ path: "/edit-order/:ID", component: <AddOrder title="Edit Order" type="Edit" />, requiredPermission: "edit-order" },
	{ path: "/view-order/aspeed/:ID", component: <ViewOrderAspeed title="Orders" />, requiredPermission: "view-order" },
	{ path: "/view-order/ariba/:ID", component: <ViewOrderAriba title="Orders" />, requiredPermission: "view-order" },

	//support
	{ path: "/support", component: <Support title="Support" />, requiredPermission: "view-support" },
	{ path: "/view-inquiry/:ID", component: <ViewInquiry title="Inquiry Details" />, requiredPermission: "view-support" },

	//review
	{ path: "/review", component: <Review title="Review" />, requiredPermission: "view-review" },
	{ path: "/view-review/:ID", component: <ViewReview title="Review Details" />, requiredPermission: "view-review" },

	//voucher
	{ path: "/voucher", component: <Vouchers title="Vouchers" />, requiredPermission: "view-marketing" },
	{ path: "/add-voucher", component: <AddVoucher title="Add Vouchers" type={"Add"} />, requiredPermission: "create-marketing" },
	{ path: "/edit-voucher/:ID", component: <AddVoucher title="Edit Vouchers" type={"Edit"} />, requiredPermission: "edit-marketing" },

	//promo code
	{ path: "/promo-code", component: <PromoCode title="Promo Codes" />, requiredPermission: "view-marketing" },
	{ path: "/add-promo-code", component: <AddPromoCode title="Add Promo Code" type={"Add"} />, requiredPermission: "create-marketing" },
	{ path: "/edit-promo-code/:ID", component: <AddPromoCode title="Edit Promo Code" type={"Edit"} />, requiredPermission: "edit-marketing" },

	//Banners
	{ path: "/banners", component: <Banners /> },
	{ path: "/add-banner", component: <AddBanner title={'Add Banner'} type={"Add"} /> },
	{ path: "/edit-banner/:ID", component: <AddBanner title={'Edit Banner'} type={"Edit"} /> },

	//Inventory
	{ path: "/inventory", component: <Inventory />, requiredPermission: "view-inventory" },
	{ path: "/inventory/:ID", component: <ViewInventoryLog title={"Inventory Log"} />, requiredPermission: "view-inventory" },

	//Report
	{ path: "/sales-report", component: <SalesReport />, requiredPermission: "view-reporting" },
	{ path: "/sales-by-product-report", component: <SalesByProduct />, requiredPermission: "view-reporting" },
	{ path: "/sales-by-category-report", component: <SalesByCategory />, requiredPermission: "view-reporting" },
	{ path: "/customer-report", component: <CustomerReport />, requiredPermission: "view-reporting" },
	{ path: "/marketing-report", component: <MarketingReport />, requiredPermission: "view-reporting" },

	// Forms
	{ path: "/form-elements", component: <FormElements /> },
	{ path: "/form-advanced", component: <FormAdvanced /> },
	{ path: "/form-editors", component: <FormEditors /> },
	{ path: "/form-mask", component: <FormMask /> },
	{ path: "/form-file-upload", component: <FormUpload multiple={true} images={false} /> },
	{ path: "/form-wizard", component: <FormWizard /> },
	{ path: "/form-xeditable", component: <FormXeditable /> },

	{ path: "/dashboard", component: <Dashboard /> },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: <Navigate to="/dashboard" />, },
];

const publicRoutes = [
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPwd /> },

	{ path: "/maintenance", component: <Maintenance /> },
	{ path: "/404", component: <Error404 /> },
	{ path: "/not-authorized", component: <NotAuthorized /> },
];

export { authProtectedRoutes, publicRoutes };

